import { useDispatch, useSelector } from 'react-redux'
import { a11ySelector, setLetterSpacing } from '../../../../redux/slices/a11y'
import TextSwitcher from '../../../reusable/Accessibility/TextSwitcher'

const LetterSpacingSwitcher = () => {
  const { letterSpacing } = useSelector(a11ySelector)
  const btnMinusDisabled = letterSpacing <= 0
  const btnPlusDisabled = letterSpacing >= 2
  const dispatch = useDispatch()

  const handleMinus = () => {
    dispatch(setLetterSpacing(letterSpacing - 0.5))
  }
  const handlePlus = () => {
    dispatch(setLetterSpacing(letterSpacing + 0.5))
  }

  return (
    <TextSwitcher
      title="Відступ між буквами"
      value="Аа"
      handleMinus={handleMinus}
      handlePlus={handlePlus}
      btnMinusDisabled={btnMinusDisabled}
      btnPlusDisabled={btnPlusDisabled}
    />
  )
}

export default LetterSpacingSwitcher
